import React from "react";
import { Redirect } from "@core/routing/redirect";
import { Path } from "@core/routing/path";
import { useCurrentProfile } from "@domain/currentProfile/hooks";

export const MyProfileRedirect: React.FC = () => {
	const currentProfile = useCurrentProfile();
	return <Redirect to={currentProfile ? Path.Profile(currentProfile) : Path.Root} />;
};
